import { render } from "./VolunteerManagementPage.vue?vue&type=template&id=6a88df2e&scoped=true"
import script from "./VolunteerManagementPage.vue?vue&type=script&lang=js"
export * from "./VolunteerManagementPage.vue?vue&type=script&lang=js"

import "./VolunteerManagementPage.vue?vue&type=style&index=0&id=6a88df2e&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/fep.theismailiusa.org/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a88df2e"]])

export default __exports__